import { getDefaultLocale } from "@/config/app.config";
import { sendGTMEvent } from "@next/third-parties/google";

export function sanitizePayload(payload: Record<string, any>): Record<string, any> {
    const safe: Record<string, any> = {};

    Object.entries(payload).forEach(([key, value]) => {
        if (value === null || value === undefined) {
            safe[key] = ""; // normalize nullish → empty string
        } else if (typeof value === "symbol") {
            safe[key] = String(value.toString()); // Symbol() → "Symbol(...)"
        } else if (typeof value === "object" && !(value instanceof Date)) {
            try {
                // stringify objects (urls, nested data, etc.)
                safe[key] = JSON.stringify(value);
            } catch {
                safe[key] = ""; // fallback if circular
            }
        } else {
            safe[key] = String(value); // number, boolean, date → string
        }
    });

    return safe;
}

const getUtmParamsFromSessionStorage = (): Record<string, string> => {
    if (typeof window === "undefined") return {};

    const utmParams: Record<string, string> = {};

    try {
        Object.keys(sessionStorage).forEach((key) => {
            if (!key.toLowerCase().startsWith("utm_")) return;

            const value = sessionStorage.getItem(key);
            if (value !== null) {
                // utmParams[key] = value;
                utmParams[key.replace(/^utm_/, "")] = value;
            }
        });
    } catch {
        return {};
    }

    return utmParams;
};

export const sendEventToGTM = (payload: any) => {
    const getCookie = (name: string): string => {
        if (typeof document === 'undefined') return 'NA';
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop()?.split(';').shift() || 'NA';
        return 'NA';
    };

    const utmParams = getUtmParamsFromSessionStorage();

    const p = {
        event: "NA", // "click | redirect | scroll | hover | open | close | submit | reset",
        type: "NA", // group
        subType: "NA", // category
        pagePath: typeof window !== 'undefined' ? window.location.pathname : "/",
        location: "NA", // section name
        campaign: decodeURIComponent(getCookie('BP_INITIATIVE')) || "NA", //'Campaign name',
        domain: getCookie('BP_DOMAIN') ? decodeURIComponent(getCookie('BP_DOMAIN')) : (typeof window !== 'undefined' ? window.location.hostname : "NA"), // 'example.com',
        market: decodeURIComponent(getCookie('market') || getCookie('NEXT_LOCALE')) || 'en', // 'pt' country,
        pageLanguage: decodeURIComponent(getCookie('NEXT_LOCALE') || getDefaultLocale()), // page language
        meetingPlaceId: decodeURIComponent(getCookie('BP_MP_ID')) || "NA", // 'SHC540'
        meetingPlaceName: decodeURIComponent(getCookie('BP_MP_NAME')) || "NA", // 'Matosinos"
        activationPage: ((): string => {
            if (typeof window === 'undefined') return 'home';

            const path = window.location.pathname;
            const title = document.title.toLowerCase().replace(/\s+/g, '-');

            // / → home, /[slug] → slug, /folder → folder
            return path === '/'
                ? 'home'
                : path.split('/').pop()?.replace(/[^\w]/g, '-') || title || 'home';
        })(), // current page name in english like: 'golden-booklet' // home
        ...utmParams,
        ...payload
    }

    try {
        console.log("GTM payload →", sanitizePayload(p));
        sendGTMEvent(sanitizePayload(p))
    } catch (err) {
        console.error("Invalid GTM payload:", p, err);
    }
}